import {NgModule} from "@angular/core";
import {SharedModule} from "../../../shared.module";
import {CatalogComponent} from "./catalog.component";
import {SideNavigationComponent} from './side-navigation/side-navigation.component';
import {CatalogHeaderComponent} from "./catalog-header/catalog-header.component";
import {CatalogRoutingModule} from './catalog-routing.module';
import {ProductCardModule} from "../../product/product-card/product-card.module";
import {ProductDrawerModule} from "../../product/product-drawer/product-drawer.module";
import {CatalogHeroComponent} from "./catalog-hero/catalog-hero.component";
import {SkinAnalyzerModule} from "../../skin-analyzer/skin-analyzer.module";

@NgModule({
    imports: [
        CatalogRoutingModule,
        ProductCardModule,
        ProductDrawerModule,
        SharedModule,
        SkinAnalyzerModule
    ],
    declarations: [
        CatalogComponent,
        CatalogHeaderComponent,
        CatalogHeroComponent,
        SideNavigationComponent,
    ]
})
export class CatalogModule {
}
